import React from 'react';

const VisionMission: React.FC = () => {
  return (
    <section className="section-padding bg-white relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5">
        <div className="absolute top-20 left-20 w-32 h-32 bg-brand-orange rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-40 h-40 bg-brand-blue rounded-full blur-3xl"></div>
      </div>
      
      <div className="container-custom relative z-10">
        <div className="text-center mb-20">
          <div className="inline-block">
            <span className="text-sm font-normal text-brand-orange uppercase tracking-wider mb-4 block">Our Foundation</span>
            <h2 className="text-5xl lg:text-6xl font-medium text-gray-900 mb-6 leading-tight">
              Vision & Mission
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-brand-blue to-brand-orange mx-auto mb-8"></div>
          </div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Driving cultural storytelling and empowering businesses through strategic, story-driven brands
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-16 items-stretch">
          {/* Vision */}
          <div className="group relative flex">
            <div className="relative bg-white p-12 rounded-3xl border border-gray-200 transition-all duration-500 flex flex-col w-full">
              <div className="flex items-center mb-8">
                <div className="w-20 h-20 bg-gradient-to-br from-brand-orange to-orange-400 rounded-2xl flex items-center justify-center mr-6">
                  <img 
                    src="/images/icons/vision-target.png" 
                    alt="Vision"
                    className="w-10 h-10 object-contain"
                  />
                </div>
                <div>
                  <h3 className="text-3xl font-medium text-gray-900 mb-2">Vision</h3>
                  <div className="w-16 h-1 bg-brand-orange rounded-full"></div>
                </div>
              </div>
              <p className="text-lg text-gray-700 leading-relaxed">
                To be the leading creative force that shapes visionary brands and drives cultural 
                storytelling across Somalia and beyond.
              </p>
            </div>
          </div>

          {/* Mission */}
          <div className="group relative flex">
            <div className="relative bg-white p-12 rounded-3xl border border-gray-200 transition-all duration-500 flex flex-col w-full">
              <div className="flex items-center mb-8">
                <div className="w-20 h-20 bg-gradient-to-br from-brand-blue to-blue-600 rounded-2xl flex items-center justify-center mr-6">
                  <img 
                    src="/images/icons/mission (1).png" 
                    alt="Mission"
                    className="w-10 h-10 object-contain"
                  />
                </div>
                <div>
                  <h3 className="text-3xl font-medium text-gray-900 mb-2">Mission</h3>
                  <div className="w-16 h-1 bg-brand-blue rounded-full"></div>
                </div>
              </div>
              <p className="text-lg text-gray-700 leading-relaxed">
                To empower businesses, organizations, and movements by creating strategic, 
                story-driven brands that connect, inspire, and lead change through bold 
                visuals and unforgettable experiences.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;
